import React, { useState, useEffect } from 'react';
import {
    Button,
    List,
    Switch,
    Typography,
    Modal as ModalAntd,
    Tooltip,
    notification,
} from 'antd';
import {
    StopOutlined,
    CheckOutlined,
    UsergroupAddOutlined,
    UsergroupDeleteOutlined,
} from '@ant-design/icons';
import { getAccessTokenApi } from '../../../../api/auth';
import {
    getCompaniesApi,
    changeActiveStatusApi,
    updateCompanyApi,
} from '../../../../api/company';

const { confirm } = ModalAntd;

export default function ListRestaurants() {
    const [loading, setLoading] = useState(true);
    const [reloadRestaurants, setReloadRestaurants] = useState(false);
    const [viewUsersActive, setViewUsersActive] = useState(true);
    const [restaurantsActive, setRestaurantsActive] = useState([]);
    const [restaurantsInactive, setRestaurantsInactive] = useState([]);
    const { Text } = Typography;

    useEffect(() => {
        const token = getAccessTokenApi();
        const filter = `isTestingCompany=${false}`;
        getCompaniesApi(token, filter).then((response) => {
            console.log(response);

            const activeRest = response.filter((ele) => ele.active === true);

            const inactiveRest = response.filter((ele) => ele.active === false);

            setRestaurantsActive(activeRest);
            setRestaurantsInactive(inactiveRest);

            setReloadRestaurants(false);
            setLoading(false);
        });
        return () => {};
    }, [reloadRestaurants]);

    return (
        <div className="list-users">
            <div className="list-users__header">
                <div className="list-users__header-switch">
                    <Switch
                        defaultChecked
                        onChange={() => setViewUsersActive(!viewUsersActive)}
                    />
                    <Text>
                        {viewUsersActive
                            ? 'Restaurantes Activos'
                            : 'Restaurantes Inactivos'}
                    </Text>
                </div>

                {/* <Button
                    type="primary"
                    onClick={addUserModal}
                    icon={<UserAddOutlined />}
                >
                    Nuevo Usuario
                </Button> */}
            </div>

            {viewUsersActive ? (
                <RestaurantsActive
                    restaurantsActive={restaurantsActive}
                    setReloadRestaurants={setReloadRestaurants}
                    loading={loading}
                />
            ) : (
                <RestaurantsInactive
                    restaurantsInactive={restaurantsInactive}
                    setReloadRestaurants={setReloadRestaurants}
                    loading={loading}
                />
            )}

            {/* <Modal
                destroyOnClose
                title={modalTitle}
                isVisible={isVisibleModal}
                setIsVisible={setIsVisibleModal}
                footer={false}
            >
                {modalContent}
            </Modal> */}
        </div>
    );
}

function RestaurantsActive(props) {
    const { Title } = Typography;
    const { restaurantsActive, setReloadRestaurants, loading } = props;

    return (
        <>
            <Title level={3}>Lista de Restaurantes Activos</Title>
            <List
                className="users-active"
                itemLayout="horizontal"
                loading={loading}
                dataSource={restaurantsActive}
                pagination={{
                    onChange: (page) => {
                        console.log(page);
                    },
                    pageSize: 6,
                }}
                renderItem={(restaurant) => (
                    <RestaurantActive
                        restaurant={restaurant}
                        setReloadRestaurants={setReloadRestaurants}
                    />
                )}
            />
        </>
    );
}

function RestaurantActive(props) {
    const { restaurant, setReloadRestaurants } = props;

    const confirmDesactiveRestaurant = () => {
        confirm({
            title: 'Desactivar compañia',
            content: `¿Estas seguro que quieres desactivar la compañia ${restaurant.name}?`,
            okText: 'Si, Desactivar',
            okType: 'danger',
            cancelText: 'No, Cancelar',
            onOk() {
                desactivateRestaurant();
            },
        });
    };

    const desactivateRestaurant = async () => {
        const token = getAccessTokenApi();
        const companyId = restaurant.companyId;

        const result = await changeActiveStatusApi(token, companyId, false);
        console.log(result);

        if (result === undefined) {
            notification['error']({
                message:
                    'Verifique su conexión a internet, si no se resuelve intente más tarde.',
            });
        } else {
            if (result.statusCode !== 200) {
                let msg = 'Ocurrio un problema, Intente mas tarde por favor.';

                if (result.statusCode === 409) {
                    msg = result.description;
                }

                notification['error']({
                    message: msg,
                });
            } else {
                setReloadRestaurants(true);
                notification['success']({
                    message: 'Restaurante desactivado exitosamente',
                });
            }
        }
    };

    const confirmPoolRestaurant = () => {
        confirm({
            title: 'Mostar usuario',
            content: `¿Estas seguro que quieres ${
                restaurant.isShownInPool ? 'quitar del ' : 'añadir al '
            } pool a ${restaurant.name}?`,
            okText: 'Si',
            okType: 'danger',
            cancelText: 'No, Cancelar',
            onOk() {
                shownInPoolRestaurant();
            },
        });
    };

    const shownInPoolRestaurant = async () => {
        const token = getAccessTokenApi();
        restaurant['isShownInPool'] = !restaurant.isShownInPool;
        console.log(restaurant);

        const result = await updateCompanyApi(token, restaurant);
        console.log(result);

        if (result === undefined) {
            notification['error']({
                message:
                    'Verifique su conexión a internet, si no se resuelve intente más tarde.',
            });
        } else {
            if (result.statusCode !== 200) {
                let msg = 'Ocurrio un problema, Intente mas tarde por favor.';

                if (result.statusCode === 409) {
                    msg = result.description;
                }

                notification['error']({
                    message: msg,
                });
            } else {
                setReloadRestaurants(true);
                notification['success']({
                    message: 'Operación realizada  exitosamente',
                });
            }
        }
    };

    return (
        <List.Item
            actions={
                restaurant.isShownInPool
                    ? [
                          <Tooltip placement="top" title="Desactivar Compañia">
                              <Button
                                  danger
                                  type="primary"
                                  onClick={confirmDesactiveRestaurant}
                                  icon={<StopOutlined />}
                              />
                          </Tooltip>,
                          <Tooltip
                              placement="top"
                              title="Quitar del Pool la Compañia"
                          >
                              <Button
                                  danger
                                  type="ghost"
                                  onClick={confirmPoolRestaurant}
                                  icon={<UsergroupDeleteOutlined />}
                              />
                          </Tooltip>,
                      ]
                    : [
                          <Tooltip placement="top" title="Desactivar Compañia">
                              <Button
                                  danger
                                  type="primary"
                                  onClick={confirmDesactiveRestaurant}
                                  icon={<StopOutlined />}
                              />
                          </Tooltip>,
                          <Tooltip
                              placement="top"
                              title="Pasar al Pool la  Compañia"
                          >
                              <Button
                                  type="primary"
                                  onClick={confirmPoolRestaurant}
                                  icon={<UsergroupAddOutlined />}
                              />
                          </Tooltip>,
                      ]
            }
        >
            <List.Item.Meta
                // avatar={<Avatar src={avatar ? avatar : NoAvatar} />}
                title={`
                    ${restaurant.name ? restaurant.name : '...'}
                `}
                description={restaurant.fiscalName}
            />
        </List.Item>
    );
}

function RestaurantsInactive({
    restaurantsInactive,
    setReloadRestaurants,
    loading,
}) {
    const { Title } = Typography;

    return (
        <>
            <Title level={3}>Lista de Usuarios Inactivos</Title>
            <List
                className="users-active"
                itemLayout="horizontal"
                loading={loading}
                dataSource={restaurantsInactive}
                pagination={{
                    onChange: (page) => {
                        console.log(page);
                    },
                    pageSize: 6,
                }}
                renderItem={(restaurant) => (
                    <RestaurantInactive
                        restaurant={restaurant}
                        setReloadRestaurants={setReloadRestaurants}
                    />
                )}
            />
        </>
    );
}

function RestaurantInactive(props) {
    const { restaurant, setReloadRestaurants } = props;

    const confirmActiveRestaurant = () => {
        confirm({
            title: 'Activar usuario',
            content: `¿Estas seguro que quieres activar a ${restaurant.name}?`,
            okText: 'Si, Activar',
            okType: 'primary',
            cancelText: 'No, Cancelar',
            onOk() {
                activateRestaurant();
            },
        });
    };

    const activateRestaurant = async () => {
        const token = getAccessTokenApi();

        const companyId = restaurant.companyId;

        const result = await changeActiveStatusApi(token, companyId, true);

        if (result === undefined) {
            notification['error']({
                message:
                    'Verifique su conexión a internet, si no se resuelve intente más tarde.',
            });
        } else {
            if (result.statusCode !== 200) {
                let msg = 'Ocurrio un problema, Intente mas tarde por favor.';

                if (result.statusCode === 409) {
                    msg = result.description;
                }

                notification['error']({
                    message: msg,
                });
            } else {
                setReloadRestaurants(true);
                notification['success']({
                    message: 'Restaurante activado exitosamente',
                });
            }
        }
    };

    return (
        <List.Item
            actions={[
                <Tooltip placement="top" title="Activar Usuario">
                    <Button
                        type="primary"
                        onClick={confirmActiveRestaurant}
                        icon={<CheckOutlined />}
                    />
                </Tooltip>,
            ]}
        >
            <List.Item.Meta
                // avatar={<Avatar src={avatar ? avatar : NoAvatar} />}
                title={`
                    ${restaurant.name ? restaurant.name : '...'}
                `}
                description={restaurant.fiscalName}
            />
        </List.Item>
    );
}

// function TableRestaurant({ restaurants }) {
//     const [selectedRowKeys, setSelectedRowKeys] = useState([]);

//     const columns = [
//         {
//             title: 'Nombre',
//             dataIndex: 'name',
//         },
//         {
//             title: 'Status',
//             key: 'active',
//             dataIndex: 'active',
//             render: (active) => (
//                 <Tag color={active ? 'green' : 'red'}>
//                     {active ? 'ACTIVO' : 'INACTIVO'}
//                 </Tag>
//             ),
//         },
//         // {
//         //     title: 'Address',
//         //     dataIndex: 'address',
//         // },
//     ];

//     const start = () => {
//         setTimeout(() => {
//             setSelectedRowKeys([]);
//         }, 1000);
//     };

//     const onSelectChange = (selectedRowKeys) => {
//         console.log('selectedRowKeys changed: ', selectedRowKeys);
//         setSelectedRowKeys(selectedRowKeys);
//         // this.setState({ selectedRowKeys });
//     };

//     const rowSelection = {
//         selectedRowKeys,
//         onChange: onSelectChange,
//     };

//     const hasSelected = selectedRowKeys.length > 0;
//     return (
//         <div>
//             <div style={{ marginBottom: 16 }}>
//                 <Button
//                     danger
//                     type="primary"
//                     onClick={start}
//                     disabled={!hasSelected}
//                     // loading={loading}
//                 >
//                     Desactivar
//                 </Button>
//                 <Button
//                     type="primary"
//                     onClick={start}
//                     disabled={!hasSelected}
//                     // loading={loading}
//                     style={{ marginLeft: 10 }}
//                 >
//                     Activar
//                 </Button>
//                 <span style={{ marginLeft: 8 }}>
//                     {hasSelected
//                         ? `Selected ${selectedRowKeys.length} items`
//                         : ''}
//                 </span>
//             </div>
//             <Table
//                 rowSelection={rowSelection}
//                 columns={columns}
//                 dataSource={restaurants}
//             />
//         </div>
//     );
// }
